import { ApolloClient, HttpLink, ApolloLink, split } from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import { createNetworkStatusNotifier } from "react-apollo-network-status";
import { useDebounce } from "use-debounce";
import { persistCache, LocalStorageWrapper } from "apollo3-cache-persist";

import graphqlMiddleware, {
  isExpiredElseFetchToken,
} from "./graphqlMiddleware";
import localCache from "./cache";
// import { dispatch } from "../../redux/index";

const { link, useApolloNetworkStatus } = createNetworkStatusNotifier();

export const useLoading = () => {
  const status = useApolloNetworkStatus();

  // Stop "loading" on error
  if (status.queryError) return false;

  const [loading] = useDebounce(
    status.numPendingQueries > 0 || status.numPendingMutations > 0,
    250
  );

  return loading;
};

const apisEndpoint = APIS_ENDPOINT; // eslint-disable no-undef;

persistCache({
  cache: localCache,
  storage: new LocalStorageWrapper(window.localStorage),
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );

  if (networkError) console.log(`[Network error]: ${networkError}`);

  // dispatch({
  //   type: "ENQUEUE_ERROR",
  //   errors: graphQLErrors,
  // });
});

const httpLink = new HttpLink({
  uri: apisEndpoint,
});

const wsLink = new WebSocketLink({
  uri:
    apisEndpoint.replace("https://", "wss://").replace("http://", "ws://") +
    "/subscriptions",
  options: {
    reconnect: true,
    lazy: true,
    connectionParams: {
      authorization: localStorage.getItem("accessToken"),
    },
  },
});

const subscriptionMiddleware = {
  applyMiddleware: async (options, next) => {
    const accessToken = await isExpiredElseFetchToken();
    if (accessToken) {
      options.authorization = accessToken;
    }

    return next();
  },
};

wsLink.subscriptionClient.use([subscriptionMiddleware]);

const httpStack = ApolloLink.from([errorLink, graphqlMiddleware, httpLink]);

const combinedLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpStack
);

export default new ApolloClient({
  link: link.concat(combinedLink),
  cache: localCache,
  defaultOptions: {
    watchQuery: {
      partialRefetch: true,
    },
  },
});
